module.exports = __webpack_public_path__ + "img/right_slide.4a6bb4fc.svg";